export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/boomerang/HomeView.vue'),
  },
  {
    meta: { title: 'menu.invoiceReview' },
    path: '/invoice-review/:id',
    name: 'invoice-review',
    component: async () => await import('@/views/boomerang/InvoiceReview.vue'),
  },
  {
    meta: { title: 'menu.ticketDetail' },
    path: '/ticket/:id',
    name: 'ticket-detail',
    component: async () => await import('@/views/boomerang/TicketDetail.vue'),
  },
  {
    meta: { title: 'menu.pageBuilder' },
    path:'/page-builder',
    name: 'page-builder',
    component: async () => await import('@/views/boomerang/PageBuilder.vue'),
  }
]
